import { Text, TypographyPage } from 'ui';

export default {
  letters: {
    i: {
      text: 'Enjoy and are energized by their own company',
    },
    s: {
      text: 'They rely on the information they get from their five senses',
    },
    t: {
      text: 'They tend to rely more on logic than emotions',
    },
    j: {
      text: 'They’re more interested in order and organization, with decisions being fixed',
    },
  },
  persons: [
    {
      slug: 'damon',
      name: 'Matt Damon',
    },
    {
      slug: 'granger',
      name: 'Hermione Granger',
    },
    {
      slug: 'gates',
      name: 'Bill Gates',
    },
  ],
  advantages: ['Responsible', 'Organized', 'Logical', 'Problem-solving'],
  disadvantages: [
    'Inflexibility',
    'Bluntness',
    'Judgment',
    'Difficulty expressing emotions',
  ],
  aboutUsCards: [
    {
      color: 'orange',
      title: 'ISTJs and friendships',
      text: 'ISTJs treat friendships as they do with many other areas of their life. They’re very dedicated to their friends and extremely loyal. This means that once you’ve gained the trust of an ISTJ, they stick by you. ISTJs appreciate this level of loyalty in return, especially from close friends.',
    },
    {
      color: 'red',
      title: 'ISTJs and work',
      text: 'ISTJs are highly responsible people in all areas of their lives. This personality type tends to put maximal effort into all projects or tasks they get involved with. If anything goes wrong, they assume responsibility.',
    },
    {
      color: 'mint',
      title: 'ISTJs and romance',
      text: 'Above all, ISTJs are loyal and dependable partners. To ISTJs, this commitment is a central element of a relationship. This means that ISTJs can be particularly hurt by broken promises or infidelity from partners. If you commit to an ISTJ, you can be sure that you’ll receive the same in return.',
    },
  ],
  aboutTypeDescription:
    'ISTJ is a Myers–Briggs personality type, also referred to as the Logistician. Each personality type has four components. For ISTJs, these are:',
  aboutTypeTextContent: (
    <TypographyPage dense>
      <Text>
        The ISTJ personality type stands for introversion, sensing, thinking,
        and judging. This personality type has also been called the Logistician
        because of these traits. Some general ISTJ traits include a quiet,
        reserved nature, an analytical approach to problem-solving, and
        stability.
      </Text>
      <Text>
        ISTJs are highly responsible people in all areas of their lives. This
        personality type tends to put maximal effort into all projects or tasks
        they get involved with. If anything goes wrong, they assume
        responsibility.
      </Text>
    </TypographyPage>
  ),
};
